module.exports = __webpack_public_path__ + "static/img/beta_bg_02.f81fdb21.svg";